import { NgIf } from '@angular/common';
import { ChangeDetectorRef } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { OpcaoMenu } from '../../shared/menus/opcao-menu.interface';
import { TabelaComponent } from '../../shared/tabela/tabela.component';
import { AfterContentChecked, Component, OnInit, } from '@angular/core';
import { OnlyNumbersDirective } from '../../directives/only-numbers.directive';
import { LayoutEditorContentService, IconeAtivo } from './layout-editor-content.service';
import { CarregamentoService } from '../../services/carregamento/carregamento.service';
import { EtapasDeEdicaoComponent } from '../../shared/etapas-de-edicao/etapas-de-edicao.component';
import { LateralNavegacaoComponent } from '../../shared/menus/lateral-navegacao/lateral-navegacao.component';

@Component({
  selector: 'app-layout-editor-condicao-qualidade',
  templateUrl: './layout-editor.component.html',
  standalone: true,
  imports: [
    NgIf,
    RouterModule,
    TabelaComponent,
    OnlyNumbersDirective,
    EtapasDeEdicaoComponent,
    LateralNavegacaoComponent,
  ],
  styleUrl: './layout-editor.component.scss',
})
export class LayoutEditorComponent implements OnInit, AfterContentChecked {
  tituloMenuLateral = '';
  opcoesMenuLateralAtivas: OpcaoMenu[] = [];
  opcoesMenuLateralInativas: OpcaoMenu[] = [];
  caminhoImagem = '';
  corFundoCabecalho = '';
  caminhoNovoResultado = '';
  exibirBotaoAnterior = false;
  rotaAnterior = '';
  exibirBotaoProximo = false;
  rotaProximo = '';
  exibirResultado = false;
  iconeAtivo: IconeAtivo = IconeAtivo.ANDARILHO;

  iconeAndarilhoPreenchido = true;
  iconeQualidadePreenchido = false;
  iconeMoedasPreenchido = false;
  iconeFinanceiroPreenchido = false;
  caminhoAtual = '';

  constructor(
    private router: Router,
    private changeDetectorRef: ChangeDetectorRef,
    private carregamentoService: CarregamentoService,
    private layoutEditorContentService: LayoutEditorContentService,
  ) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.carregamentoService.carregandoDados.next(true);
    });

    setTimeout(() => {
      this.carregamentoService.carregandoDados.next(false);
    }, 3000);

    this.layoutEditorContentService.tituloMenuLateral$.subscribe((titulo) => {
      this.tituloMenuLateral = titulo;
    });

    this.layoutEditorContentService.opcoesMenuLateralAtivas$.subscribe(
      (opcoes) => {
        this.opcoesMenuLateralAtivas = opcoes;
      },
    );

    this.layoutEditorContentService.opcoesMenuLateralInativas$.subscribe(
      (opcoes) => {
        this.opcoesMenuLateralInativas = opcoes;
      },
    );

    this.layoutEditorContentService.caminhoImagem$.subscribe((caminho) => {
      this.caminhoImagem = caminho;
    });

    this.layoutEditorContentService.corFundoMenuLateral$.subscribe((cor) => {
      this.corFundoCabecalho = cor;
    });

    this.layoutEditorContentService.exibirBotaoAnterior$.subscribe((exibir) => {
      this.exibirBotaoAnterior = exibir;
    });

    this.layoutEditorContentService.rotaAnterior$.subscribe((rota) => {
      this.rotaAnterior = rota;
    });

    this.layoutEditorContentService.exibirBotaoProximo$.subscribe((exibir) => {
      this.exibirBotaoProximo = exibir;
    });

    this.layoutEditorContentService.rotaProximo$.subscribe((rota) => {
      this.rotaProximo = rota;
    });

    this.layoutEditorContentService.exibirResultado$.subscribe((exibir) => {
      this.exibirResultado = exibir;
    });

    this.layoutEditorContentService.iconeAtivo$.subscribe((icone) => {
      this.iconeAtivo = icone;
      this.preencheIconeEtapaAtual(icone);
    });

    const rotaAtual = this.router.url.split('/');
    this.caminhoAtual = '/' + rotaAtual[1];
    this.definiCaminhoNovoResultado(rotaAtual[1]);
  }

  ngAfterContentChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  public navegarParaRotaAnterior(): void {
    this.router.navigate([this.rotaAnterior]);
  }

  public navegarParaRotaProximo(): void {
    this.router.navigate([this.rotaProximo]);
  }

  private definiCaminhoNovoResultado(rotaAtual: string): void {
    if (rotaAtual === 'relatorio1') {
      this.caminhoNovoResultado = '/relatorio-caq';
    } else if (rotaAtual === 'relatorio2') {
      this.caminhoNovoResultado = '/relatorio2/resultado-previsao-orcamentaria';
    } else if (rotaAtual === 'relatorio3') {
      this.caminhoNovoResultado = '/relatorio-financiamento-das-escolas';
    }
  }

  protected preencheIconeEtapaAtual(icone: IconeAtivo): void {
    switch (icone) {
      case IconeAtivo.ANDARILHO:
        this.iconeAndarilhoPreenchido = true;
        this.iconeFinanceiroPreenchido = false;
        this.iconeMoedasPreenchido = false;
        this.iconeQualidadePreenchido = false;
        break;
      case IconeAtivo.QUALIDADE:
        this.iconeAndarilhoPreenchido = false;
        this.iconeFinanceiroPreenchido = false;
        this.iconeMoedasPreenchido = false;
        this.iconeQualidadePreenchido = true;
        break;
      case IconeAtivo.MOEDAS:
        this.iconeAndarilhoPreenchido = false;
        this.iconeFinanceiroPreenchido = false;
        this.iconeMoedasPreenchido = true;
        this.iconeQualidadePreenchido = false;
        break;
      case IconeAtivo.FINANCEIRO:
        this.iconeAndarilhoPreenchido = false;
        this.iconeFinanceiroPreenchido = true;
        this.iconeMoedasPreenchido = false;
        this.iconeQualidadePreenchido = false;
        break;
    }
  }
}
